import React from "react";
//outsource
import { Row, Col, InputNumber, Form } from "antd";

//components

const IncomeBank = ({ edit, bank, setBank }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setBank(value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item initialValue={0} name="bankTransfer">
      <InputNumber
        min={0}
        prefix="$"
        value={bank}
        onChange={handleChange}
        disabled={!edit}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      />
    </Form.Item>
  );
};

export default IncomeBank;
